import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icon/close-image.png'
import _imports_1 from '../../../assets/icon/downaload-image.png'


const _withScopeId = n => (_pushScopeId("data-v-618420cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "progress"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "dialog-box-h5-footer"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "message-image",
    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)), ["self"]))
  }, [
    _createElementVNode("img", {
      class: "message-img",
      src: _ctx.data.url
    }, null, 8, _hoisted_1),
    (_ctx.data.progress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("progress", {
            value: _ctx.data.progress,
            max: "1"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "dialog",
          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)), ["self"]))
        }, [
          (!_ctx.isH5)
            ? (_openBlock(), _createElementBlock("header", _hoisted_4, [
                _createElementVNode("i", {
                  class: "icon icon-close",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)), ["stop"]))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["dialog-box", [_ctx.isH5 ? 'dialog-box-h5' : '']]),
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)), ["self"]))
          }, [
            _createElementVNode("img", {
              class: _normalizeClass([_ctx.isWidth ? 'isWidth' : 'isHeight']),
              src: _ctx.data.message.payload.imageInfoArray[0].url,
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)), ["self"]))
            }, null, 10, _hoisted_5),
            (_ctx.isH5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)))
                  }, _hoisted_8),
                  _createElementVNode("p", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.downloadImage(_ctx.data.message)), ["stop"]))
                  }, _hoisted_10)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}